// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-categories {
  padding-top: 24px;
  padding-bottom: 48px;
}

.menu-categories__title {
  margin: 0 0 28px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: clamp(32px, 4vw, 48px);
  line-height: 1.15;
  color: #4e3f3a;
}

.menu-categories__message {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #4e3f3a;
}

.menu-categories__message--error {
  color: #c00;
}

.menu-categories__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px 24px;
  max-width: 1320px;
  margin: 0 auto;
}

.menu-categories__card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  border-radius: 26px;
  overflow: visible;
}

.menu-categories__card-image {
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
  aspect-ratio: 417 / 249;
  border: 1px solid #fff;
  border-radius: 26px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  background-color: #e8e0d8;
  background-size: cover;
  background-position: center;
}

.menu-categories__card-caption {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  align-self: stretch;
  min-height: 120px;
  margin-top: -44px;
  padding: 48px 24px 22px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: clamp(22px, 2.5vw, 36px);
  line-height: 1.2;
  color: #4e3f3a;
  background: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 26px;
}

.menu-categories__card--combo .menu-categories__card-image {
  position: relative;
}

.menu-categories__card--combo .menu-categories__card-image::after {
  content: 'Комбо';
  position: absolute;
  left: 12px;
  top: 12px;
  z-index: 3;
  padding: 8px 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.06em;
  color: #fff;
  background: #2d6a4f;
  border-radius: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

@media (max-width: 1024px) {
  .menu-categories__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .menu-categories__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MenuCategoriesPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".menu-categories {\n  padding-top: 24px;\n  padding-bottom: 48px;\n}\n\n.menu-categories__title {\n  margin: 0 0 28px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size: clamp(32px, 4vw, 48px);\n  line-height: 1.15;\n  color: #4e3f3a;\n}\n\n.menu-categories__message {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  color: #4e3f3a;\n}\n\n.menu-categories__message--error {\n  color: #c00;\n}\n\n.menu-categories__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px 24px;\n  max-width: 1320px;\n  margin: 0 auto;\n}\n\n.menu-categories__card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  border-radius: 26px;\n  overflow: visible;\n}\n\n.menu-categories__card-image {\n  position: relative;\n  z-index: 2;\n  display: block;\n  width: 100%;\n  aspect-ratio: 417 / 249;\n  border: 1px solid #fff;\n  border-radius: 26px;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  background-color: #e8e0d8;\n  background-size: cover;\n  background-position: center;\n}\n\n.menu-categories__card-caption {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: flex-end;\n  align-self: stretch;\n  min-height: 120px;\n  margin-top: -44px;\n  padding: 48px 24px 22px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: clamp(22px, 2.5vw, 36px);\n  line-height: 1.2;\n  color: #4e3f3a;\n  background: #fff;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 26px;\n}\n\n.menu-categories__card--combo .menu-categories__card-image {\n  position: relative;\n}\n\n.menu-categories__card--combo .menu-categories__card-image::after {\n  content: 'Комбо';\n  position: absolute;\n  left: 12px;\n  top: 12px;\n  z-index: 3;\n  padding: 8px 16px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.06em;\n  color: #fff;\n  background: #2d6a4f;\n  border-radius: 14px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n@media (max-width: 1024px) {\n  .menu-categories__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 700px) {\n  .menu-categories__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
